module.exports = __webpack_public_path__ + "img/Dokumentbevakningen_v3.77372f29.png";